import * as React from 'react';
import { AdacHeadline, AdacText } from '@adac-de/component-library';
import styles from '../container/content-container.module.scss';

type ErrorMessageProps = {
  headline: string;
  subline: string | JSX.Element;
};

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ headline, subline }) => (
  <div className={styles.errorMessage}>
    <AdacHeadline tagName="div" styleAs="h3">
      {headline}
    </AdacHeadline>
    <AdacText type="medium">{subline}</AdacText>
  </div>
);
